export enum FieldTypeEnum {
    CHECKBOX = 'Checkbox',
    CLOSEDLISTMULTY = 'ClosedListMulti',
    CLOSEDLISTGROUP = 'ClosedListGroup',
    CLOSEDLISTAUTOCOMPLETE = 'ClosedListAutocomplete',
    CLOSEDLIST = 'ClosedList',
    ClosedListLookup = 'ClosedListLookup',
    DATE = 'Date',
    DATERANGE = 'DateRange',
    DateSeason = 'DateSeason',
    LANGUAGES = 'Languages',
    KEYWORDS = 'Keywords',
    RICHTEXT = 'RichText',
    RADIO = 'Radio',
    STRING = 'String',
    TEXTAREA = 'Textarea',
    ACCESSRIGHTS = 'AccessRight',
    Label = 'Label',
    DOI = 'DOI',
    HANDLE = 'HANDLE',
    Authors = 'Authors',
    Files = 'Files',
    Links = 'Links',
    FilesLinks = 'FilesLinks',
    Topics = 'Topics',
    RelatedAssets = 'RelatedAssets',
    RelatedGrants = 'RelatedGrants',
    GeoSpatial = 'GeoSpatial',
    GeoBoundingBox = 'GeoBoundingBox',
    Identifiers = 'Identifiers',
    ExternalOrganization = 'ExternalOrganization',
    PublicationStatus = 'PublicationStatus',
}

export type FieldType = (typeof FieldTypeEnum)[keyof typeof FieldTypeEnum];
